import { useTranslation } from 'react-i18next'

const useTourResults = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-tourResults-BookingTimer',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.bookingTimer')}
          </p>
          <span>{t('tour.results.bookingTimerDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-HotelsSorting',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.hotelsSorting')}
          </p>
          <span>{t('tour.results.hotelsSortingDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-RefineSearch',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.refineYourSearch')}
          </p>
          <span>{t('tour.results.refineYourSearchDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-QuotationButton',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.quotation')}
          </p>
          <span>{t('tour.results.quotationDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-CardListButton',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.toggleView')}
          </p>
          <span>{t('tour.results.toggleViewDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-HotelImage',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.hotelImage')}
          </p>
          <span>{t('tour.results.hotelImageDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-HotelLocation',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.hotelLocation')}
          </p>
          <span>{t('tour.results.hotelLocationDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-RoomInfo',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.hotelRoomInfo')}
          </p>
          <span>{t('tour.results.hotelRoomInfoDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-PriceInfo',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.priceInfo')}
          </p>
          <span>{t('tour.results.priceInfoDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-MiniQuotationButton',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.miniQuotationButton')}
          </p>
          <span>{t('tour.results.miniQuotationButtonDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourResults-SeeMoreTaxButton',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.seeMoreTaxButton')}
          </p>
          <span>{t('tour.results.seeMoreTaxButtonDescription')}</span>
        </div>
      ),
    },

    {
      selector: '.joyride-tourResults-ReserveButton',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.results.reserveButton')}
          </p>
          <span>{t('tour.results.reserveButtonDescription')}</span>
        </div>
      ),
    },
  ]
}

export default useTourResults
